import script from "./PresenterTips.vue?vue&type=script&setup=true&lang=js"
export * from "./PresenterTips.vue?vue&type=script&setup=true&lang=js"

import "./PresenterTips.vue?vue&type=style&index=0&id=1847ed68&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1847ed68"]])

export default __exports__